import "./style.css"
import React from "react";

export default function Titulo(props){
    return(
        <div className="titulo verde">
            <h4>{props.description}</h4>
        </div>
    )
}